function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clothes-0_svg__id-9a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32 217.738C32 186.403 59.187 161 92.723 161h46.554C172.813 161 200 186.403 200 217.738V232H32v-14.262z",
  fill: "#09CAC7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.093 160.968c0 20.155-22.204 36.494-49.594 36.494s-49.595-16.339-49.595-36.494 22.205-36.494 49.595-36.494 49.594 16.339 49.594 36.494z",
  fill: "#09CAC7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149.706 220.496c-.789 0-1.428.611-1.428 1.361 0 .754.638 1.366 1.428 1.366.785 0 1.42-.612 1.42-1.366 0-.75-.634-1.361-1.42-1.361zm0 2.546c-.696 0-1.202-.518-1.202-1.186 0-.663.506-1.181 1.202-1.181.691 0 1.194.518 1.194 1.181.001.668-.502 1.186-1.194 1.186zm.728-1.542c0-.253-.141-.403-.563-.403h-.695v1.521h.194v-.703h.357l.455.703h.233l-.481-.703c.283-.005.5-.116.5-.415zm-.766.268h-.297v-.539h.455c.195 0 .399.029.399.266 0 .309-.331.273-.557.273zm4.279-11.088c.001-.316.003-.752-.088-.965-.223-.515-.456-.696-1.233-1.238-4.046-2.83-5.9-5.267-6.601-6.185-.81.857-.919.951-1.168 1.145 1.351 1.731 2.823 3.482 6.088 5.945-1.908-.319-4.695-.682-8.469-2.42.05.024-.228 1.726-.184 1.751 2.797 1.4 5.116 1.907 8.254 2.486-2.074.992-4.24 1.769-6.357 2.696.033-.014.882 1.274 1.011 1.43 2.235-.751 4.053-1.441 6.736-2.753 0 .07.041.72.041 1.523.007 2.22.107 4.158.586 9.099.003.033 1.24.091 1.624.093-.005-.062-.25-11.155-.24-12.607zm13.252-3.718c-3.775 1.737-6.563 2.1-8.468 2.42 3.263-2.464 4.736-4.215 6.087-5.946-.249-.194-.359-.287-1.169-1.145-.699.919-2.555 3.356-6.601 6.185-.775.542-1.009.723-1.231 1.238-.092.214-.089.649-.088.965.01 1.452-.236 12.546-.241 12.605.384-.001 1.62-.059 1.623-.092.48-4.94.58-6.879.587-9.099 0-.803.04-1.453.04-1.523 2.683 1.311 4.502 2.002 6.735 2.753.131-.156.98-1.444 1.014-1.43-2.119-.928-4.284-1.704-6.359-2.696 3.139-.579 5.457-1.087 8.254-2.486.046-.024-.233-1.727-.183-1.749zm-9.419-4.137c0-1.619-1.372-2.932-3.063-2.932-1.692 0-3.063 1.313-3.063 2.932 0 1.622 1.371 2.934 3.063 2.934 1.691-.001 3.063-1.312 3.063-2.934z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M160.749 172.344a.937.937 0 01.284 1.293c-6.104 9.542-20.038 19.092-35.689 20.494-23.341 2.09-40.752-6.435-51.525-14.783a.936.936 0 011.146-1.479c10.491 8.13 27.445 16.437 50.212 14.398 15.077-1.351 28.49-10.587 34.279-19.639a.937.937 0 011.293-.284z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.723 227.405v-36.494h1.871v36.494h-1.871zm34.621.936v-36.494h1.871v36.494h-1.871z",
  fill: "#000"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clothes-0_svg__id-9a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h232v232H0z"
})));

function SvgClothes0(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/media/clothes-0.db7b7fb4.svg";
export { SvgClothes0 as ReactComponent };